import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactCrop from 'react-image-crop'
import { observable, action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'

const propTypes = {
  image: PropTypes.string.isRequired,
  crop: PropTypes.shape({
    aspect: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
}

@observer
class ImageCrop extends Component {
  @observable crop = { ...this.props.cropParams, unit: 'px' }

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  get scales() {
    if (!this.imageRef) return { scaleX: 1, scaleY: 1 }

    const { height, naturalHeight, naturalWidth, width } = this.imageRef
    const scaleX = naturalWidth / width
    const scaleY = naturalHeight / height

    return { scaleX, scaleY }
  }

  @action setCrop = (crop) => {
    this.crop = crop
  }

  onCropChange = (crop) => {
    this.setCrop({ ...this.crop, ...crop })
    this.props.onCropChange(crop)
  }

  onImageLoaded = (image) => {
    this.imageRef = image.target

    const { width, height } = this.imageRef
    const isFullSelection =
      this.props.isFullSelection || !this.crop.height || (this.crop.width === width && this.crop.height === height)
    const { scaleX, scaleY } = this.scales
    const aspect = this.crop.aspect || width / height

    if (isFullSelection) {
      this.setCrop({
        ...this.crop,
        x: 0,
        y: 0,
        width: Math.min(width, height * aspect),
        height: Math.min(height, width / aspect),
      })
      this.props.onCropChange({})
    } else {
      this.onCropChange({
        ...this.crop,
        x: this.crop.x / (scaleX || 1),
        y: this.crop.y / (scaleY || 1),
        width: width / (scaleX || 1),
        height: height / (scaleY || 1),
      })
    }
  }

  onCropComplete = (crop) => {
    this.makeClientCrop(crop)
  }

  makeClientCrop = (crop) => {
    if (this.imageRef && crop.width && crop.height) {
      const { scaleX, scaleY } = this.scales

      this.props.onCrop({
        x: crop.x * scaleX,
        y: crop.y * scaleY,
        width: crop.width * scaleX,
        height: crop.height * scaleY,
      })
    }
  }

  componentDidUpdate = ({ cropParams: prevCrop }) => {
    const { cropParams } = this.props
    const { height, width, x, y, fullSize } = cropParams

    if (
      prevCrop.height !== height ||
      prevCrop.width !== width ||
      prevCrop.x !== x ||
      prevCrop.y !== y ||
      prevCrop.fullSize !== fullSize
    )
      this.onCropChange(cropParams)
  }

  render() {
    const { image, onRemove } = this.props

    return (
      <div>
        {image && (
          <ReactCrop
            crop={this.imageRef ? this.crop : { width: 0, height: 0 }}
            onComplete={this.onCropComplete}
            onChange={this.onCropChange}
            aspect={this.crop.aspect}
          >
            <img src={image} onLoad={this.onImageLoaded} />
          </ReactCrop>
        )}
        {onRemove && (
          <div className='elo-modal__remove-button' onClick={onRemove}>
            <i className='fas fa-trash-alt' />
          </div>
        )}
      </div>
    )
  }
}

ImageCrop.displayName = 'ImageCrop'
ImageCrop.propTypes = propTypes

export default ImageCrop
